/* Display-only English Title Case for storefront headings.
   Keeps Shopify product, article and section data unchanged.
   This is needed because CSS capitalize does not lowercase ALL CAPS source text.
*/
(function () {
  'use strict';

  var SELECTOR = [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    '.h1', '.h2', '.h3', '.h4', '.h5', '.h6',
    '.section-header__title',
    '.latest-stories__heading', '.latest-stories__title',
    '.article__title',
    '.rc-location-hero__heading', '.rc-heading-richtext',
    '.home-product-teaser__intro', '.home-product-teaser__title',
    '.rcp-home__title', '.rcp-card__title',
    '.grid-product__title', '.collection-item__title',
    '.rc-collection__description-title', '.rc-collection__categories-title',
    '.redcamp-product-details__heading', '.rc-service-card__heading',
    '.rc-pdp-guide__title', '.rc-pdp-guide__related-heading',
    '.rcm-preview__heading', '.variant-comparison__title',
    '.footer__title', '.promo-grid__title',
    '.hero__title', '.hotspots__title',
    '.newsletter-popup__success-heading',
    '.cgs-title', '.nh-title',
    '.rc-pdp-guide__card-title', '.text-with-icons__title',
    '.text-with-icons__block-title', '.zig-zag-title',
    '.mb__tabs_title', '.step-title', '.tool-tip-trigger__title',
    '.promo-banner__title', '.jdgm-carousel-title', '.jdgm-revs-tab__title',
    '.ecom-predictive-search__heading', '.predictive-search-heading',
    '.product-recommendations__title', '.search-results-heading',
    '.variant-comparison__variant-title', '.newsletter-reminder__message'
  ].join(',');

  var EXCLUDED = [
    '.product-single__title', '.ecom-product__heading', '.ecom-product-single__title',
    '.site-header__logo', '.visually-hidden', '.giftcard__amount',
    '[date-days-placeholder]', '[date-hours-placeholder]',
    '[date-minutes-placeholder]', '[date-seconds-placeholder]'
  ].join(',');

  var ACRONYMS = {
    REDCAMP: true, REI: true, USA: true, USD: true,
    SKU: true, PDP: true, SEO: true, LED: true, USB: true,
    GPS: true, BBQ: true, DIY: true, FAQ: true, AI: true, API: true
  };

  function toTitleCase(text) {
    return text.replace(/[A-Za-z]+(?:['’][A-Za-z]+)*/g, function (word) {
      if (ACRONYMS[word]) return word;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
  }

  function isAllowedHeading(element) {
    return element && element.nodeType === 1 && !element.matches(EXCLUDED) &&
      !element.closest('.product-single__title, .ecom-product__heading, .ecom-product-single__title, .site-header__logo');
  }

  function formatHeading(element) {
    if (!isAllowedHeading(element)) return;
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (!node.parentElement || node.parentElement.closest('script, style, noscript, svg')) continue;
      if (!/[A-Za-z]/.test(node.nodeValue)) continue;
      var formatted = toTitleCase(node.nodeValue);
      if (formatted !== node.nodeValue) node.nodeValue = formatted;
    }
  }

  function findLocationSubheadings(root) {
    var nodes = [];
    if (root.nodeType === 1 && root.matches('.rc-location-hero__body p')) nodes.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('.rc-location-hero__body p').forEach(function (el) { nodes.push(el); });
    }
    nodes.forEach(function (paragraph) {
      var value = paragraph.textContent.trim();
      // Only standalone all-uppercase, short label paragraphs (e.g. OUR CONTACTS).
      if (value.length > 1 && value.length <= 72 && /^[^a-z]*[A-Z][^a-z]*$/.test(value) &&
          /[A-Z]{2}/.test(value) && !paragraph.querySelector('a, button, img, input')) {
        paragraph.classList.add('rc-heading-richtext');
      }
    });
  }

  function process(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) return;
    findLocationSubheadings(root);
    if (root.nodeType === 1 && root.matches(SELECTOR)) formatHeading(root);
    if (root.querySelectorAll) root.querySelectorAll(SELECTOR).forEach(formatHeading);
  }

  function start() {
    process(document);
    document.addEventListener('shopify:section:load', function (event) { process(event.target); });
    document.addEventListener('shopify:block:select', function (event) { process(event.target); });

    // Dynamic product cards and theme-editor sections may be inserted after loading.
    // Inspect added nodes only; do not watch scrolling or other attribute changes.
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) process(node);
          else if (node.nodeType === 3 && record.target && record.target.nodeType === 1) {
            var parent = record.target;
            var heading = parent.closest(SELECTOR);
            if (heading) formatHeading(heading);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
